module.exports = __webpack_public_path__ + "media/images/icons/outlined/snippets-146ecb9d38721f74c982cfeb3441c4a4.svg";